<template>
  <div id="home">
    <el-row :gutter="20">
      <el-col :span="10">
        <div class="item">
          <div class="title">
            <img :src="icon1">
            今日实时数据
          </div>
          <div class="content">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info">
                  <div class="info-title">
                    <div class="icon-box" style="padding-left:1px;">
                      <img :src="icon1_1">
                    </div>
                    <div class="name">报名学员</div>
                  </div>
                  <div class="num">{{data.TodaySignStudentCount||0}}</div>
                  <div class="plus">昨日 {{ (data.TodaySignStudentCount-data.YesterdaySignStudentCount)<0?"":"+" }}{{ (data.TodaySignStudentCount||0) - (data.YesterdaySignStudentCount||0) }}
                  </div>
                </div>
                <div class="info" style="background-color:#e6f8ea;">
                  <div class="info-title">
                    <div class="icon-box">
                      <img :src="icon1_2">
                    </div>
                    <div class="name">带教教练</div>
                  </div>
                  <div class="num">{{data.TodayCoachCount||0}}</div>
                  <div class="plus">昨日 {{ (data.TodayCoachCount-data.YesterdayCoachCount)<0?"":"+" }}{{ (data.TodayCoachCount||0) - (data.YesterdayCoachCount||0) }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info" style="background-color:#fbf3e8;">
                  <div class="info-title">
                    <div class="icon-box">
                      <img :src="icon1_3" style="margin-top:1px;height: 30px;width: 30px;">
                    </div>
                    <div class="name">培训学员</div>
                  </div>
                  <div class="num">{{data.TodayTrainStudentCount||0}}</div>
                  <div class="plus">昨日 {{ (data.TodayTrainStudentCount-data.YesterdayTrainStudentCount)<0?"":"+" }}{{ (data.TodayTrainStudentCount||0) - (data.YesterdayTrainStudentCount||0) }}</div>
                </div>
                <div class="info" style="background-color:#d5d1e8;">
                  <div class="info-title">
                    <div class="icon-box">
                      <img :src="icon1_4">
                    </div>
                    <div class="name">培训车辆</div>
                  </div>
                  <div class="num">{{data.TodayCarCount||0}}</div>
                  <div class="plus">昨日 {{ (data.TodayCarCount-data.YesterdayCarCount)<0?"":"+" }}{{ (data.TodayCarCount||0) - (data.YesterdayCarCount||0) }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="right-box">
                  <div class="info" style="background: none;margin-bottom:12px;">
                    <div class="info-title">
                      <div class="name y50">
                        科目二
                        <br />
                        预约数量
                      </div>
                    </div>
                    <div class="num right">{{data.Subject2BookCount||0}}</div>
                    <div class="plus right">昨日 {{ (data.Subject2BookCount-data.Subject2BookCount2)<0?"":"+" }}{{ (data.Subject2BookCount||0) - (data.Subject2BookCount2||0) }}</div>
                  </div>
                  <div class="set"></div>
                  <div class="info" style="background: none;">
                    <div class="info-title">
                      <div class="name y50">
                        科目三
                        <br />
                        预约数量
                      </div>
                    </div>
                    <div class="num right">{{data.Subject3BookCount||0}}</div>
                    <div class="plus right">昨日 {{ (data.Subject3BookCount-data.Subject3BookCount2)<0?"":"+" }}{{ (data.Subject3BookCount||0) - (data.Subject3BookCount2||0) }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="item" style="height:225px;margin-bottom:20px;">
          <div class="title">
            <img :src="icon2">
            累计汇总数据
          </div>
          <div class="total">
            <div class="total-info">
              <div class="total-num">
                {{showNum(data.StudentCount)}}
                <span class="ww" v-if="data.StudentCount>10000">万</span>
              </div>
              <div class="total-name">学员总数</div>
              <div class="total-plus">昨日 {{ (data.StudentCount-data.StudentCount2)<0?"":"+" }}{{ (data.StudentCount||0) - (data.StudentCount2||0) }}</div>
            </div>
            <div class="total-info">
              <div class="total-num">
                {{showNum(data.CoachCount)}}
                <span class="ww" v-if="data.CoachCount>10000">万</span>
              </div>
              <div class="total-name">教练总数</div>
              <div class="total-plus">昨日 {{ (data.CoachCount-data.CoachCount2)<0?"":"+" }}{{ (data.CoachCount||0) - (data.CoachCount2||0) }}</div>
            </div>
            <div class="total-info">
              <div class="total-num">
                {{showNum(data.CarCount)}}
                <span class="ww" v-if="data.CarCount>10000">万</span>
              </div>
              <div class="total-name">教练车总数</div>
              <div class="total-plus">昨日 {{ (data.CarCount-data.CarCount2)<0?"":"+" }}{{ (data.CarCount||0) - (data.CarCount2||0) }}</div>
            </div>
          </div>
        </div>
        <div class="item" style="height:225px;" v-if="UserType!=1">
          <div class="title">
            <img :src="icon3">
            运营汇总数据
          </div>
          <div class="total">
            <div class="total-info">
              <div class="total-num">{{data.SchoolCount||0}}</div>
              <div class="total-name">合作驾校</div>
              <div class="total-plus">昨日 {{ (data.SchoolCount-data.SchoolCount2)<0?"":"+" }}{{ (data.SchoolCount||0) - (data.SchoolCount2||0) }}</div>
            </div>
            <div class="total-info">
              <div class="total-num">{{data.DeviceCount||0}}</div>
              <div class="total-name">实操设备</div>
              <div class="total-plus">昨日 {{ (data.DeviceCount-data.DeviceCount2)<0?"":"+" }}{{ (data.DeviceCount||0) - (data.DeviceCount2||0) }}</div>
            </div>
            <div class="total-info">
              <div class="total-num">{{data.SimulatorCount||0}}</div>
              <div class="total-name">模拟设备</div>
              <div class="total-plus">昨日 {{ (data.SimulatorCount-data.SimulatorCount2)<0?"":"+" }}{{ (data.SimulatorCount||0) - (data.SimulatorCount2||0) }}</div>
            </div>
          </div>
        </div>
        <div class="item" style="height:225px;" v-else-if="UserType==1">
          <div class="title">
            <img :src="icon3">
            提醒信息
          </div>
          <div class="total">
            <div class="total-info">
              <div class="total-num">{{data.ReviewCarCount||0}}</div>
              <div class="total-name">待年审车辆</div>
              <div class="total-plus">昨日 {{ (data.ReviewCarCount-data.ReviewCarCount2)<0?"":"+" }}{{ (data.ReviewCarCount||0) - (data.ReviewCarCount2||0) }}</div>
            </div>
            <div class="total-info">
              <div class="total-num">{{data.InsureCarCount||0}}</div>
              <div class="total-name">待继保车辆</div>
              <div class="total-plus">昨日 {{ (data.InsureCarCount-data.InsureCarCount2)<0?"":"+" }}{{ (data.InsureCarCount||0) - (data.InsureCarCount2||0) }}</div>
            </div>
            <div class="total-info">
              <div class="total-num">{{data.ComEvaCount||0}}</div>
              <div class="total-name">投诉和评价</div>
              <div class="total-plus">昨日 {{ (data.ComEvaCount-data.ComEvaCount2)<0?"":"+" }}{{ (data.ComEvaCount||0) - (data.ComEvaCount2||0) }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="item" style="height:470px;position: relative;">
          <div class="title">
            <img :src="icon4">
            <span style="cursor:pointer;margin-left:5px;" @click="more">通知公告</span>
          </div>
          <div class="more" @click="more">更多</div>
          <div class="notice">
            <div class="notice-item" v-for="(item,index) in data.Articles" :key="item.ArticleId" :style="index==2?'border:none;':''">
              <div class="notice-title" @click="toDetails(item.ArticleId)">{{item.Title}}</div>
              <div class="notice-time">{{$commonJs.toDateString(item.PublishTime)}}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="UserType!=1">
      <el-col :span="8">
        <div class="char-item">
          <div class="title">
            <img :src="icon5">
            学员名额出库趋势
          </div>
          <line-chart ref="lineChart" height="210px"></line-chart>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="char-item">
          <div class="title">
            <img :src="icon6">
            备案学员趋势
          </div>
          <line-chart ref="lineChart2" height="210px"></line-chart>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="char-item">
          <div class="title">
            <img :src="icon7">
            备案学时趋势
          </div>
          <line-chart ref="lineChart3" height="210px"></line-chart>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-else-if="UserType==1">
      <el-col :span="8">
        <div class="char-item">
          <div class="title">
            <img :src="icon5">
            报名学员趋势
          </div>
          <line-chart ref="lineChart4" height="210px"></line-chart>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="char-item">
          <div class="title">
            <img :src="icon5">
            结业学员趋势
          </div>
          <line-chart ref="lineChart5" height="210px"></line-chart>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="char-item">
          <div class="title">
            <img :src="icon5">
            预约学员趋势
          </div>
          <line-chart ref="lineChart6" height="210px"></line-chart>
        </div>
      </el-col>
    </el-row>
    <list-dialog ref="listDialog" in-dialog selectable></list-dialog>
    <view-dialog ref="viewDialog"></view-dialog>
  </div>
</template>

<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import date from "@/components/dashboard/cards/date";
import lineChart from "@/components/dashboard/charts/lineChart";
import listDialog from "@/components/dashboard/articles/listDialog";
import viewDialog from "@/components/dashboard/articles/viewDialog";
import api from "@/api/sy/user";
export default {
  components: {
    date,
    lineChart,
    listDialog,
    viewDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      icon1: require("../assets/index/icon1.png"),
      icon2: require("../assets/index/icon2.png"),
      icon3: require("../assets/index/icon3.png"),
      icon4: require("../assets/index/icon4.png"),
      icon5: require("../assets/index/icon5.png"),
      icon6: require("../assets/index/icon6.png"),
      icon7: require("../assets/index/icon7.png"),
      icon1_1: require("../assets/index/icon1_1.png"),
      icon1_2: require("../assets/index/icon1_2.png"),
      icon1_3: require("../assets/index/icon1_3.png"),
      icon1_4: require("../assets/index/icon1_4.png"),
      UserType: loginInfo.UserType,
      loop: null,
      data: {
        // TodaySignStudentCount: 2,
        // YesterdaySignStudentCount: 3,
        Articles: [],
      },
    };
  },
  beforeMount() {
    let self = this;
    self.getData();
    this.loop = setInterval(() => {
      self.getData();
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.loop);
  },
  methods: {
    getData() {
      api.getWorkbench().then(res => {
        if(res.Code==0) {
          this.data = res.Data;
          // this.data.PlaceStat = [
          //   { Text: "2日", Value: 10, },
          //   { Text: "3日", Value: 18, },
          //   { Text: "4日", Value: 13, },
          //   { Text: "5日", Value: 16, },
          //   { Text: "6日", Value: 22, },
          // ];
          // this.data.RecordStudentStat = [
          //   { Text: "2日", Value: 20, },
          //   { Text: "3日", Value: 38, },
          //   { Text: "4日", Value: 13, },
          //   { Text: "5日", Value: 26, },
          //   { Text: "6日", Value: 15, },
          // ];
          // this.data.RecordHourStat = [
          //   { Text: "2日", Value: 22, },
          //   { Text: "3日", Value: 36, },
          //   { Text: "4日", Value: 18, },
          //   { Text: "5日", Value: 26, },
          //   { Text: "6日", Value: 19, },
          // ];
          if(this.UserType!=1) {
            if(this.data.PlaceStat) this.$refs.lineChart.initChart(this.data.PlaceStat,"","");
            if(this.data.RecordStudentStat) this.$refs.lineChart2.initChart(this.data.RecordStudentStat,"","");
            if(this.data.RecordHourStat) this.$refs.lineChart3.initChart(this.data.RecordHourStat,"","");
          } else {
            if(this.data.SignStat) this.$refs.lineChart4.initChart(this.data.SignStat,"","");
            if(this.data.GraduationStat) this.$refs.lineChart5.initChart(this.data.GraduationStat,"","");
            if(this.data.BookStat) this.$refs.lineChart6.initChart(this.data.BookStat,"","");
          }
        }
      })
    },
    toDetails(id) {
      this.$refs.viewDialog.openDetailsById(id);
    },
    more() {
      this.$refs.listDialog.open().then(that => {
        that.getData();
      });
    },
    showNum(v) {
      if(v > 0) {
        if(v > 10000) {
          return Math.floor(v/1000) / 10
        } else return v;
      } else return 0;
    },
  }
};
</script>
<style  lang="scss" scoped>
#home {
  background-color: #f4f7fe;
  padding: 20px;
  min-width: 1300px;
  min-height: calc(100vh - 140px);
  .item {
    background-color: #fff;
    border-radius: 18px;
    height: 470px;
    padding: 0 28px;
    .title {
      letter-spacing: 1px;
      line-height: 65px;
      font-size: 18px;
      padding-top: 5px;
      & > img {
        height: 22px;
        width: 22px;
        vertical-align: sub;
      }
    }
    .content {
      .info {
        background-color: #f5e6e9;
        border-radius: 24px;
        // padding: 20px 26px 20px 20px;
        padding: 20px 1.35vw 20px 1.05vw;
        margin-bottom: 20px;
        // height: 175px;
        .info-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 18px;
          letter-spacing: 1px;
          .icon-box {
            background-color: #fff;
            border-radius: 14px;
            padding: 5px 0;
            height: 44px;
            width: 44px;
            text-align: center;
            img {
              height: 34px;
              width: 34px;
            }
          }
          .name {
            white-space: nowrap;
          }
        }
        .num {
          font-size: 42px;
          font-weight: bold;
          margin-top: 24px;
        }
        .plus {
          color: #999;
          font-size: 14px;
          padding-left: 0.3rem;
        }
        .right {
          text-align: right;
        }
      }
      .right-box {
        background-color:#f1f3ff;
        border-radius:24px;
        position:relative;
        .set {
          position: absolute;
          right: 17%;
          top: 50%;
          height: 5px;
          width: 18%;
          background-color: #aed0f5;
        }
        .y50 {
          width: 100%;
          text-align: right;
          transform: translateY(24%);
        }
      }
    }
    .total {
      display: flex;
      justify-content: space-between;
      height: 140px;
      align-items: center;
      padding-bottom: 10px;
      .total-info {
        width: 33%;
        text-align: center;
        font-weight: bold;
        .total-num {
          font-size: 40px;
          margin-bottom: 10px;
        }
        .total-name {
          margin-bottom: 5px;
          font-size: 18px;
        }
        .total-plus {
          color: #999;
          font-weight: normal;
          font-size: 14px;
        }
      }
    }
    .notice {
      .notice-item {
        border-bottom: 1px dashed #ddd;
        padding: 8px 0 25px;
        .notice-title {
          cursor: pointer;
          font-size: 18px;
          letter-spacing: 1px;
          line-height: 36px;
          margin-bottom: 10px;
          height: 72px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .notice-time {
          color: #999;
        }
      }
    }
    .more {
      position: absolute;
      right: 28px;
      top: 30px;
      color: #999;
      font-size: 14px;
      letter-spacing: 1px;
      cursor: pointer;
    }
  }
  .char-item {
    background-color: #fff;
    border-radius: 18px;
    height: 300px;
    margin-top: 18px;
    .title {
      padding: 0 28px;
      letter-spacing: 1px;
      line-height: 65px;
      font-size: 18px;
      padding-top: 5px;
      & > img {
        height: 22px;
        width: 22px;
        vertical-align: sub;
      }
    }
  }
}
.ww {
  font-size: 24px;
  vertical-align: 3px;
}
</style>